import _extends from "@babel/runtime/helpers/esm/extends";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import SecurityScanOutlinedSvg from "@ant-design/icons-svg/es/asn/SecurityScanOutlined";
import AntdIcon from "../components/AntdIcon";
var SecurityScanOutlined = function SecurityScanOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: SecurityScanOutlinedSvg
  }));
};
if (process.env.NODE_ENV !== 'production') {
  SecurityScanOutlined.displayName = 'SecurityScanOutlined';
}
export default /*#__PURE__*/React.forwardRef(SecurityScanOutlined);